import React, { useState, useEffect } from 'react'
import CurrentSiteTile from 'components/CurrentSiteTile'
import SelectSiteModal from 'components/SelectSiteModal'
import { useSelector } from 'react-redux'

const SiteSelector = () => {
  const [showSelectSiteModal, setShowSelectSiteModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  // Track loading states from various data sources
  const isLoadingInstructorData = useSelector(
    state => state.lmsManager.isFetching,
  )
  const isLoadingContentData = useSelector(
    state => state.contentManager?.isLoading,
  )
  const isLoadingCourseManager = useSelector(
    state => state.courseManager?.isLoading,
  )

  useEffect(() => {
    // When any of these loading states changes, update our local loading state
    setIsLoading(
      isLoadingInstructorData ||
        isLoadingContentData ||
        isLoadingCourseManager ||
        false,
    )
  }, [isLoadingInstructorData, isLoadingContentData, isLoadingCourseManager])

  const closeSelectSiteModal = () => {
    if (showSelectSiteModal) {
      setShowSelectSiteModal(false)
    }
  }

  return (
    <>
      <SelectSiteModal
        handleClose={closeSelectSiteModal}
        show={showSelectSiteModal}
      />

      <CurrentSiteTile
        handleClick={() => setShowSelectSiteModal(true)}
        isLoading={isLoading}
      />
    </>
  )
}

export default SiteSelector
